import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormTextarea } from "src/core/components/custom-ui/form-textarea";
import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { Diligence } from "src/core/gql/graphql";
import { useUpsertDiligenceForm } from "src/core/hooks/folder/useUpsertDiligenceForm";

type UpsertDiligenceModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  diligence: Diligence | null;
  setDiligenceToEdit: (diligence: Diligence | null) => void;
};

export default function UpsertDiligenceModal({
  open,
  setOpen,
  diligence,
  setDiligenceToEdit,
}: UpsertDiligenceModalProps) {
  const { t } = useTranslation();

  const { form, onSubmit, isLoading } = useUpsertDiligenceForm(
    setOpen,
    diligence,
    setDiligenceToEdit
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="modal-add-stakeholder"
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="modal-add-stakeholder-header">
          <DialogTitle className="uppercase">
            {t(diligence ? "form.editDiligence.modal.title" : "form.addDiligence.modal.title")}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t(
              diligence
                ? "form.editDiligence.modal.description"
                : "form.addDiligence.modal.description"
            )}
          </DialogDescription>
        </DialogHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FormTextarea
              name="name"
              label={t("form.addDiligence.name")}
              required
              control={form.control}
            />
            <DialogFooter className="flex flex-row justify-center gap-x-40 border-t border-border pt-10 sticky bottom-0 bg-gray-xlight h-fit">
              <Button
                variant="link"
                onClick={(event) => {
                  event.preventDefault();
                  form.reset();
                  setDiligenceToEdit(null);
                  setOpen(false);
                }}
              >
                {t("global.form.cancel")}
              </Button>
              <Button type="submit" variant="default" loading={isLoading} className="w-[120px]">
                {t(diligence !== null ? "form.editDiligence.submit" : "form.addDiligence.submit")}
              </Button>
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
